<template>
  <v-list-item @click="clickHandler">
    <v-list-item-icon v-if="icon" class="mr-2">
      <v-icon :size="20">{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-title class="mr-2" :style="listItemStyles">{{
      title
    }}</v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"

export default defineComponent({
  name: "SingleMenuItem",
  props: {
    icon: String,
    title: String,
    clickHandler: {
      type: Function,
      required: false,
    },
    path: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const { fontFamily, fontWeightRegular, rootFontSize } = THEME.typography
    const { textColor } = THEME.colors.light

    const clickHandler = () => {
      if (props.path) {
        window.location.href = props.path
      } else {
        props.clickHandler?.()
      }
    }

    return {
      clickHandler,
      listItemStyles: {
        fontFamily,
        fontSize: `${0.9 * rootFontSize}px`,
        fontWeight: fontWeightRegular,
        color: textColor,
      },
    }
  },
})
</script>
